// if size if xsmall, we only 1 column
// if size if small, we only 1 column
// if size if medium, we only 2 column

import { Box, Button, Nav, ResponsiveContext, Text } from "grommet";
import { useCallback, useContext, useEffect, useState } from "react";
import SidebarComponent from "../../../layout/SidebarComponent";
import { ResponsiveGrid } from "../../../ResponsiveGrid";
import { Clear } from "grommet-icons";

// if size if large or xlarge, we 2 columns with 2/3 1/3 proportions
const columns = {
    xsmall: ["flex"],
    small: ["flex"],
    medium: ["flex"],
    large: ["flex", "flex"],
    xlarge: ["flex", "flex", "flex"]
};

// if size if xsmall, we have 2 rows
// if size if small, we have 2 rows
// if size if medium, we have 2 rows
// if size if large or xlarge, we have 1 row
const rows = {
    xsmall: ["flex"],
    small: ["flex"],
    medium: ["flex"],
    large: ["flex"],
    xlarge: ["flex"]
};

const gap = {
    xsmall: 'small',
    small: 'small',
    medium: 'small',
    large: 'small',
    xlarge: 'small'
}

const layoutAreas = {
    xsmall: {
        direction: 'column',
        categoryProps: { flex: "grow" },
        gridProps: { }
    },
    small: {
        direction: 'column',
        categoryProps: { flex: "grow" },
        gridProps: { }
    },
    medium: {
        direction: 'column',
        categoryProps: { flex: "grow" },
        gridProps: {  }
    },
    large: {
        direction: 'row',
        categoryProps: { basis: '35%'  },
        gridProps: { basis: '65%' }
    },
    xlarge: {
        direction: 'row',
        categoryProps: { basis: '35%'  },
        gridProps: { basis: '65%' }
    },
}

function groupByCategoryCode(items) {
	return items.reduce((acc, item) => {
		const code = item.category.code;
		if (!acc[code]) {
			acc[code] = {
				category: item.category,
				items: [],
			};
		}
		acc[code].items.push(item);
		return acc;
	}, {});
}

function getUniqueCategories(items) {
	const seen = new Map();
	items.forEach((item) => {
		const code = item.category.code;
		if (!seen.has(code)) {
			seen.set(code, item.category);
		}
	});
	return Array.from(seen.values());
}

export const SidebarGridSection = ({ items, selected, onClick }) => {

    const size = useContext(ResponsiveContext);

    const [categories, setCategories] = useState([]);
    const [categoryItems, setCategoryItems] = useState();
    const [activeCategory, setActiveCategory] = useState();

    useEffect(() => {
        if (items) {
            const uniqueCategoryies = getUniqueCategories(items);
            setCategories(uniqueCategoryies);

            const categoryItemsByCode = groupByCategoryCode(items);
            setCategoryItems(categoryItemsByCode)
        }
    }, [items])

    useEffect(() => {
        if (!categoryItems) return;
        
        if (selected && selected.category) {
            setActiveCategory(categoryItems[selected.category.code]);
        } else {
            const firstKey = Object.keys(categoryItems)[0];

            setActiveCategory(categoryItems[firstKey]);
        }
    }, [categoryItems, selected])

    const handleCategorySelect = useCallback((category) => {
        setActiveCategory(categoryItems[category.code]);
    }, [categoryItems])

    return (
        <Box gap="medium" direction={layoutAreas[size].direction}>
            <Box {...layoutAreas[size].categoryProps}>
                <Nav gap="small">
                    {categories.map(item => (<SidebarButton item={item} active={item.code === activeCategory?.category.code} onClick={handleCategorySelect} />))}
                </Nav>
            </Box>
            <Box {...layoutAreas[size].gridProps} height={'60vh'} overflow="auto">
                {activeCategory && <ResponsiveGrid
                    overrideRows={rows}
                    overrideColumns={columns}
                    // areas={areas}
                    gap={gap[size]}
                    margin="none"
                >
                    {activeCategory.items.map((item) => <ItemCard item={item} onClick={() => onClick(item)} selected={item.id === selected?.id} />)}
                </ResponsiveGrid>}
            </Box>
        </Box>
    )
}

const SidebarButton = ({ item, active, onClick }) => {

    const [isActiveHover, setActiveHover] = useState(false);

    return (
        <Box direction="row" pad={{ vertical: 'small', horizontal: '18px' }} onClick={() => onClick(item)} style={{ position: "relative" }} round="xsmall" background={active ? 'background-contrast' : 'none'} hoverIndicator focusIndicator={false} onMouseEnter={() => setActiveHover(true)} onMouseLeave={() => setActiveHover(false)}>
            {(isActiveHover || active) && <Box width={'6px'} style={{ position: "absolute", left: 0, top: 0, bottom: 0, borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' }} background={'brand'}></Box>}
            <Button label={<Text style={{ whiteSpace: 'nowrap' }}>{item.name}</Text>} plain fill justify="start" />
        </Box>
    )
}

const ItemCard = ({ item, onClick, selected = false }) => {

    return (
        <Box key={item.id} align="center" justify="center" border={selected ? { color: 'brand', size: '2px' } : null} background={'background-contrast'} round="small" pad={'small'} gap="small" onClick={onClick}>
            <Box height={'200px'} align="center" justify="center">
                {item.component}
            </Box>
            <Box align="center" justify="center">
                <Text textAlign="center">{item.name}</Text>
            </Box>
        </Box>
    )
}